import React from 'react';
import { createRoot, Root } from 'react-dom/client';

import overall from './store/overall';
import filter from './store/filter';
import storeCurrentVehicle from '../d-search-bar/store/current-vehicle';
import storeAlternativeSearch from '../d-search-bar/store/alternative';
import storeVehicleBrands from '../d-search-bar/store/vehicle-brands';

import titleByLang from './utils/titleByLang';
import { getVTypeName } from './utils/vehicleType';

import App from './app';
import { setOverallListeners } from './store/overall/listeners';
import { setCarLists } from '../d-search-bar/utils/set-car-lists';

let entryPoint: HTMLElement;
let root: Root;

const initApp = (): void => {
  // Settings before render component

  // Overall
  setOverallListeners();
  // Overall - Base URL (Craft page slug)
  overall.setBaseUrl(entryPoint.dataset.link);

  // Overall - Where to buy page link
  overall.setWTBLink(entryPoint.dataset?.wtb);

  // Overall - set title
  overall.setTitle(entryPoint.dataset.title);

  // Overall - Is VIN available
  if (entryPoint.dataset.hasOwnProperty('isVin')) {
    overall.setIsVINAvailable(true);
  }

  // Initial Make
  if (entryPoint.dataset.initialMake) {
    storeVehicleBrands.setInitialMake(entryPoint.dataset.initialMake);
  }

  // Current Car
  if (entryPoint.dataset.car) {
    const initialCar = JSON.parse(entryPoint.dataset.car);
    const vehicleType = getVTypeName(initialCar.vehicle_type);
    const id = initialCar.tid;
    const model = vehicleType !== 'pv'
      ? titleByLang(initialCar.model, overall.langId)
      : initialCar.model_group;
    const type = initialCar.filters.types.find(el => el.key === id).val;
    const car = {
      id,
      brand: titleByLang(initialCar.maker, overall.langId),
      model,
      year: initialCar.start_year
        ? `${initialCar.start_year}${initialCar.end_year ? ` — ${initialCar.end_year}` : '+'}`
        : 0,
      body: titleByLang(initialCar.body, overall.langId),
      volume: `${initialCar.volume} ${titleByLang(
        initialCar.fuel,
        overall.langId,
      )}`,
      type,
      vehicleType,
    };

    storeCurrentVehicle.setCurrent(car);
    overall.setPrefix(`${vehicleType}/${id}`);
    setCarLists(JSON.parse(entryPoint.dataset.car), car);
  }

  // Referral Search String
  if (entryPoint.dataset.referralSearch) {
    storeAlternativeSearch.setCurrent(entryPoint.dataset.referralSearch);
  }

  // Active categories array
  if (entryPoint.dataset.levels) {
    filter.setInitialLevels(JSON.parse(entryPoint.dataset.levels));
  }

  root = createRoot(entryPoint);
  root.render(React.createElement(App));
};

const init = (): void => {
  entryPoint = document.querySelector('#denso-catalog');

  if (entryPoint) {
    initApp();
  }
};

export default {
  init,
};
